<template>
  <main id="contenu-principal" :class="{ 'small-headings': allowValidation }">
    <div class="fr-grid-row">
      <div class="fr-col">
        <h1>Conditions Générales d'Utilisation (CGU)</h1>
      </div>
    </div>
    <section aria-labelledby="preambule">
      <h2 id="preambule">Préambule</h2>
      <ol>
        <li>Objet</li>
        <li>Éditeur du site</li>
        <li>Définitions</li>
        <li>Accès au site</li>
        <li>Les obligations des parties prenantes</li>
        <li>Propriété intellectuelle</li>
        <li>Données personnelles</li>
        <li>Cookies</li>
        <li>Sécurité</li>
        <li>Modifications des CGU</li>
        <li>Droit applicable</li>
      </ol>
    </section>

    <section aria-labelledby="article-1">
      <h2 id="article-1">1. Objet</h2>

      <p>
        Les présentes Conditions Générales d’Utilisation (CGU) ont pour objet de
        définir les modalités d’accès et d’utilisation des sites
        [vao.social.gouv.fr destiné] aux OVA et [admin-social.gouv.fr] destiné
        aux agents de la DGCS, des DREETS et des DDETS. Ces sites sont dédiés à
        la gestion des Vacances Adaptées Organisées pour les adultes en
        situation de handicap.
      </p>

      <p>
        L’Utilisateur, afin de pouvoir utiliser le service VAO en ligne, doit
        accepter sans réserve les présentes conditions générales d’utilisation
        (« CGU ») et leurs éventuelles mises à jour.
      </p>

      <p>
        Le service VAO en ligne est un téléservice qui permet à l’Utilisateur,
        d’accéder et de renseigner plusieurs formulaires : de l’organisme de
        vacances, de déclaration de séjour, d’événements indésirables graves et
        d’assurer la transmission de ces sujets par voie électronique en lien
        avec les agents de l’état compétents et dont dépend l’utilisateur.
      </p>

      <p>
        Ce service permet également à l’Utilisateur de suivre en ligne le
        traitement de ses déclarations.
      </p>

      <p>La mise en place de ce téléservice permet de :</p>
      <ul>
        <li>
          faciliter l’émission des déclarations de séjours par des organisateurs
        </li>
        <li>
          faciliter l’émission d’événements indésirables graves par des
          organisateurs (EIG)
        </li>
        <li>
          améliorer le traitement des déclarations de séjours et EIG par les
          DDETS et les DREETS
        </li>
        <li>améliorer les temps de traitement des échanges</li>
      </ul>
    </section>

    <section aria-labelledby="article-2">
      <h2 id="article-2">2. Éditeur du site</h2>
      <p>
        Le site est édité par la Direction Générale de la Cohésion Sociale, dans
        le cadre de la Fabrique Numérique des Ministères Sociaux.
      </p>
    </section>

    <section aria-labelledby="article-3">
      <h2 id="article-3">3. Définitions</h2>
      <p>
        Dans le cadre des présentes, les termes suivants ont la signification
        qui leur est donnée au présent article :
      </p>

      <ul>
        <li>
          « CGU » ou « Conditions » : vise les présentes conditions générales
          d’utilisation
        </li>
        <li>
          « Déclaration » : Déclaration de séjours et Déclaration d’événements
          indésirables graves correspondant au formulaire de Déclaration CERFA
          n°12672*04 dématérialisé et au modèle de formulaire d’EIG transmis par
          mail aux services déconcentrés de l’Etat le 5 juillet 2024, ainsi
          qu’aux pièces justificatives associées
        </li>
        <li>« DGCS » : Direction Générale de la Cohésion Sociale</li>
        <li>
          « DNUM » : Direction du Numérique du Ministère de la Santé et des
          Solidarités
        </li>
        <li>« EIG » : Evénements indésirables graves</li>
        <li>« Organisateurs » : Organisateurs de Vacances Adaptées (OVA)</li>
        <li>
          « Utilisateur » : personne utilisant le service pour effectuer et
          traiter une déclaration
        </li>
        <li>
          « Site » ou « Service en ligne » ou « téléservice » : application «
          VAO en ligne » accessibles aux adresses suivantes :
          [vao.social.gouv.fr] pour les OVA et [admin-vao.social.gouv.fr] pour
          les agents de l’Etat (DGCS, DREETS, DDETS)
        </li>
      </ul>
    </section>
    <section aria-labelledby="article-4">
      <h2 id="article-4">4. Accès au site</h2>

      <p>
        L’accès au site est libre et gratuit. Il nécessite une création de
        compte.
      </p>

      <p>
        Le site est accessible 24h/24 et 7j/7, sauf en cas de force majeure ou
        d’événements hors du contrôle de l’éditeur.
      </p>

      <section aria-labelledby="article-4-1">
        <h3 id="article-4-1">
          4.1. Prérequis : acceptation des présentes Conditions
        </h3>

        <p>
          L’Utilisateur prend connaissance et accepte les présentes CGU à la
          connexion, afin de pouvoir continuer à naviguer sur le Site.
        </p>

        <p>
          Ces Conditions sont susceptibles d’être modifiées à tout moment par la
          DGCS, notamment pour prendre en compte les modifications techniques du
          Site ou pour être mises en conformité avec la législation applicable.
        </p>

        <p>
          Après chaque modification des CGU, l’Utilisateur est invité, à la
          connexion à son compte, à prendre connaissance et à accepter les
          nouvelles Conditions.
        </p>

        <p>
          L’absence de validation des nouvelles conditions générales
          d’utilisation entraine une redirection vers la page d’authentification
          sans pouvoir se connecter à SI VAO.
        </p>
      </section>

      <section aria-labelledby="article-4-2">
        <h3 id="article-4-2">4.2. Les fonctionnalités du site</h3>

        <ol>
          <li>
            Le Service en ligne permet à l’Utilisateur de créer un compte et de
            déposer une ou plusieurs déclaration(s) dans les conditions définies
            au paragraphe 4 – Modalités de dépôt d’une déclaration.
          </li>
          <li>
            Le Service en ligne transmet, en fonction de type de déclaration,
            une déclaration à la DDETS du lieu de séjour dont dépend ce dernier
            et/ou une déclaration à la DREETS dont dépend l’agrément de
            l’utilisateur.
          </li>
          <li>
            L’agent de l’état instruit la déclaration dans le Système
            d’Information de son périmètre et pourra, le cas échéant, demander à
            l’organisateur de compléter son dossier (ajout de pièces
            justificatives au dossier via le Service en ligne).
          </li>
          <li>
            Le Site permet aux utilisateurs, dans le cadre d’une déclaration, de
            transmettre en ligne les documents de leur choix.
          </li>
          <li>
            Dans le cadre de la réalisation d’une déclaration et de son
            traitement, le Service en ligne adresse par courriel à l’Utilisateur
            les confirmations et accusés de réception de :
            <ul>
              <li>validation de compte</li>
              <li>confirmation du dépôt d’une déclaration</li>
              <li>
                demande de pièces justificatives complémentaires (le cas
                échéant)
              </li>
              <li>
                changement de statut de la déclaration ou d’informations
                complémentaires (nombre de personnels et vacanciers)
              </li>
            </ul>
          </li>
        </ol>

        <p>
          Ces courriels sont adressés à l’adresse courriel renseignée par
          l’Utilisateur lors de la création de son compte.
        </p>
      </section>
    </section>

    <section aria-labelledby="article-5">
      <h2 id="article-5">5. Modalités de dépôt d’une Déclaration</h2>

      <section aria-labelledby="article-5-1">
        <h3 id="article-5-1">5.1 Création d’un compte</h3>

        <p>Création d’un compte SI VAO en ligne</p>

        <p>
          Pour transmettre une Déclaration auprès de la DDETS dont relève un
          lieu de séjour ou auprès de la DREETS dont il relève, l’Utilisateur
          doit préalablement créer et activer un compte sur le Site et
          renseigner les informations suivantes :
        </p>

        <ul>
          <li>courriel valide</li>
          <li>mot de passe</li>
          <li>données d’identité (nom d’usage, prénom)</li>
          <li>téléphone</li>
          <li>SIRET</li>
        </ul>
      </section>

      <section aria-labelledby="article-5-2">
        <h3 id="article-5-2">5.2. Renseignement du formulaire en ligne</h3>

        <p>
          Après avoir renseigné les informations nécessaires à la création de
          son compte, l’Utilisateur reçoit un courriel contenant la confirmation
          de sa demande, celle-ci étant adressée à un interlocuteur différent
          selon la situation : un OVA si un compte du même organisme existe déjà
          ; à la DREETS d’agrément si l’OVA est inconnu de la plateforme.
        </p>

        <p>
          Quand cet interlocuteur a validé la demande, l’utilisateur reçoit un
          lien d’activation du compte.
        </p>

        <p>
          Tant que le compte de l’Utilisateur n’est pas validé, le Site ne
          permet pas à l’utilisateur d’y accéder et une mention est affichée
          précisant que la demande est en cours de traitement. Il n’est pas
          possible de renvoyer un courriel de demande.
        </p>

        <p>
          Lors de la création de son compte l'Utilisateur choisit un mot de
          passe. Ce mot de passe est strictement personnel et l’Utilisateur
          s’engage à le garder secret.
        </p>

        <p>
          L’Utilisateur peut réinitialiser son mot de passe à l’aide du
          formulaire prévu à cet effet accessible sur la page de login depuis le
          lien « Mot de passe oublié ? ».
        </p>

        <p>
          L’Utilisateur renseigne le formulaire de déclaration en ligne
          (conforme au CERFA n°12672*04 en vigueur pour les Déclarations de
          séjours) en veillant à compléter toutes les informations obligatoires.
          L’Utilisateur peut effectuer plusieurs types de déclarations.
        </p>
      </section>

      <section aria-labelledby="article-5-3">
        <h3 id="article-5-3">5.3. Pièces justificatives</h3>

        <p>
          Pour le traitement des déclarations, l’Utilisateur doit
          obligatoirement joindre les pièces justificatives suivantes :
        </p>

        <ul>
          <li>Agrément</li>
          <li>
            Hébergement :
            <ul>
              <li>Statut « ERP/ NON ERP »</li>
              <li>
                Si l’hébergement est un ERP : la dernière attestation de passage
                de la commission de sécurité datant de moins de 5 ans et le
                dernier arrêté d’autorisation du maire
              </li>
              <li>
                Si l’hébergement n’est pas un ERP : la production de la réponse
                du propriétaire ou exploitant de l’hébergement indiquant les
                raisons pour lesquelles le lieu d’hébergement n’est pas soumis à
                la réglementation ERP
              </li>
            </ul>
          </li>
        </ul>

        <p>
          Toute Déclaration considérée comme incomplète par un agent de l’état
          fera l’objet d’une demande de compléments.
        </p>

        <p>
          Il est également possible pour l’Utilisateur de joindre d’autres
          pièces justificatives de manière optionnelle : documents relatifs à
          l’organisation des transports, documents relatifs aux informations
          d’ordre sanitaire, aux personnels ou organismes prévus pour encadrer
          des activités spécifiques.
        </p>
      </section>
    </section>
    <section aria-labelledby="article-6">
      <h2 id="article-6">6. Les obligations des parties prenantes</h2>

      <section aria-labelledby="article-6-1">
        <h3 id="article-6-1">6.1. Les obligations de l’Utilisateur</h3>

        <p>
          L’utilisation du Site implique l’engagement par l’Utilisateur de
          respecter les présentes Conditions.
        </p>

        <p>
          L’Utilisateur s’engage à ne pas porter atteinte ou tenter de porter
          atteinte à l’intégrité, au fonctionnement ou à la sécurité du Site.
        </p>

        <p>
          L'utilisateur du service numérique VAO s'engage à ne pas inscrire des
          données à caractère personnel sauf si un champ le demande
          explicitement, conformément à la définition de la Commission nationale
          de l’informatique et des libertés (CNIL) et aux dispositions légales
          et réglementaires en vigueur, notamment le Règlement Général sur la
          Protection des Données (RGPD) et la loi Informatique et Libertés.
        </p>

        <p>
          Il lui appartient de s'assurer de l'exactitude, de la légitimité, de
          la proportionnalité et de la pertinence des données fournies.
        </p>

        <p>
          L’utilisateur s’engage à assurer la sécurité des données, en
          particulier leur confidentialité, en prenant toutes les précautions
          nécessaires. Toute utilisation inappropriée, frauduleuse ou illicite
          du service numérique VAO engage exclusivement la responsabilité de
          l'utilisateur.
        </p>

        <p>
          Le Site est un téléservice d’échanges de documents entre l’Utilisateur
          et la DDETS/DREETS respectivement compétente. Il n’a pas pour fonction
          d’être un espace de stockage et d’archivage des documents échangés
          entre l’Utilisateur et la DGCS.
        </p>

        <p>
          En cas de manquement par un Utilisateur à l’une ou plusieurs de ces
          règles, la DGCS se réserve le droit, sans préavis ni mise en demeure,
          de suspendre unilatéralement, temporairement ou définitivement le
          compte de l’Utilisateur à l’origine du manquement.
        </p>

        <p>
          En utilisant ce Service en ligne, l’Utilisateur s’engage sur la
          véracité des informations transmises lors du dépôt de sa Déclaration.
        </p>
      </section>

      <section aria-labelledby="article-6-2">
        <h3 id="article-6-2">
          6.2. Les obligations de la DDETS et de la DREETS
        </h3>

        <p>
          En vue du traitement de la demande déposée par l’Utilisateur, la DDETS
          et DREETS recueillent les données renseignées par l’Utilisateur parmi
          lesquelles figurent obligatoirement :
        </p>

        <ul>
          <li>
            celles figurant dans l’article 8.1 des présentes CGU, données à
            caractère personnel
          </li>
          <li>les documents renseignés dans l’article 5.3 des présentes CGU</li>
        </ul>

        <p>
          Des pièces complémentaires (documents) peuvent être demandées par la
          DDETS ou DREETS dans le cadre du traitement de la Déclaration déposée
          par l’Utilisateur.
        </p>
      </section>

      <section aria-labelledby="article-6-3">
        <h3 id="article-6-3">6.3. Les obligations de la DGCS</h3>

        <p><strong>Evolutions du Service en ligne</strong></p>

        <p>
          L’éditeur s’efforce de fournir des informations exactes et à jour.
          Toutefois, il ne saurait être tenu responsable des erreurs, omissions
          ou résultats liés à une mauvaise utilisation du site.
        </p>

        <p>
          La DGCS peut faire évoluer le Service en ligne. Elle peut ajouter
          régulièrement des fonctionnalités, modifier l'interface et apporter
          toute autre modification pour tenir compte des évolutions
          règlementaires.
        </p>

        <p>
          La DGCS est responsable des développements et du bon fonctionnement du
          Site. Un processus structuré a été mis en place de manière à ce que
          les évolutions soient testées préalablement à toute mise à
          disposition.
        </p>

        <p>
          Si toutefois l’Utilisateur rencontre un dysfonctionnement, il est
          libre de le signaler à l’adresse :
          <a
            href="https://vao-assistance.atlassian.net/servicedesk/customer/portals"
            rel="noopener noreferrer"
            target="_blank"
          >
            https://vao-assistance.atlassian.net/servicedesk/customer/portals
          </a>
        </p>

        <p><strong>Maintenance du Service en ligne</strong></p>

        <p>
          La DGCS est responsable de la maintenance du Site. Pour cette raison,
          elle peut suspendre temporairement l’accès au service en ligne. Dans
          le cadre d’une correction urgente et non programmée, la DGCS se
          réserve également la possibilité d’interrompre le service.
        </p>

        <p>
          La DGCS n’est tenue à aucune obligation de résultat quant au
          fonctionnement du Site et à la disponibilité du contenu. Par
          conséquent, l’Utilisateur reconnaît expressément que la DGCS pourra à
          tout moment bloquer l’accès à tout ou partie du Site ou du contenu.
        </p>

        <p>
          La DGCS garantit que les opérations de maintenance ne modifient pas
          les informations renseignées au préalable par les Utilisateurs sur le
          Site.
        </p>

        <p>
          La DGCS se réserve également le droit de bloquer, sans information
          préalable ni compensation financière, les usagers mettant en péril
          l'utilisation du Site par d'autres Utilisateurs. Cela permet notamment
          d'anticiper d'éventuelles cyber-attaques.
        </p>
      </section>
    </section>

    <section aria-labelledby="article-7">
      <h2 id="article-7">7. Propriété intellectuelle</h2>

      <p>
        L’ensemble des éléments constitutifs du contenu du Site est la propriété
        exclusive de la DGCS. Tous les contenus présents sur le site (textes,
        images, logos, vidéos, etc.) sont protégés par le droit de la propriété
        intellectuelle. Toute reproduction ou utilisation non autorisée est
        interdite.
      </p>

      <p>
        La DGCS accorde à chaque Utilisateur, à titre personnel, non-exclusif et
        gratuit un droit d'utilisation du Site pour les seules fins d'une
        utilisation conforme aux finalités de celui-ci telles que prévues par la
        réglementation, pour son usage propre et dans le strict cadre des
        opérations autorisées aux termes des présentes CGU.
      </p>
    </section>
    <section aria-labelledby="article-8">
      <h2 id="article-8">8. Données personnelles</h2>

      <p>
        Ce Site vise à faciliter la transmission et la gestion par les DDETS et
        les DREETS utilisant l’outil, des déclarations de séjour, sur la base
        des articles L. 412-12, R. 412-8 à R. 412-17-1 du code du tourisme.
      </p>

      <p>
        En tant qu’Opérateur du Service en ligne, la DNUM assure la mise en
        œuvre des mesures de sécurité destinées à garantir la confidentialité et
        l’intégrité de la conservation, de la sauvegarde et des transmissions de
        données à caractère personnel enregistrées via le Site.
      </p>

      <section aria-labelledby="article-8-1">
        <h3 id="article-8-1">8.1. Données à caractère personnel</h3>

        <p>
          Les données renseignées dans les formulaires ainsi que les pièces
          jointes sont transmises aux DDETS et/ou DREETS, en leur qualité de
          destinataires, afin d'assurer le traitement et la conservation des
          Déclarations dans le cadre du système d'information « SI VAO ».
        </p>

        <p>
          Dans l’hypothèse où les DDETS ou DREETS mettent en œuvre des
          traitements poursuivant des finalités autres que celles prévues par le
          « SI VAO », elles assument alors la qualité de responsables de
          traitement au sens du Règlement Général sur la Protection des Données
          (RGPD).
        </p>

        <p>
          À ce titre, elles sont tenues de mettre en œuvre les mesures
          techniques et organisationnelles appropriées pour garantir la
          sécurité, la confidentialité et l’intégrité des données à caractère
          personnel, ainsi que le respect des droits des personnes concernées
          conformément à la réglementation en vigueur (RGPD et Loi Informatique
          et Libertés).
        </p>

        <p>
          Afin de pouvoir émettre une Déclaration, l’Organisateur doit fournir
          un certain nombre de données à caractère personnel strictement
          nécessaires à son bon traitement. S’il ne fournit pas ces données, il
          ne pourra transmettre sa Déclaration à aucune DDETS ou DREETS via le
          Service en ligne. Certaines données peuvent être automatiquement
          recueillies.
        </p>

        <p>Voici la liste des données à caractère personnel obligatoires :</p>

        <h4>Données du compte Utilisateur :</h4>
        <ul>
          <li>Email</li>
          <li>Nom d’usage</li>
          <li>Prénom</li>
          <li>SIRET</li>
        </ul>

        <h4>
          Informations relatives à l’encadrant d’une Déclaration de Séjour :
        </h4>
        <ul>
          <li>Nom</li>
          <li>Prénoms</li>
          <li>Date de naissance</li>
          <li>Compétences</li>
          <li>Fonction</li>
          <li>Téléphone</li>
        </ul>

        <h4>
          Informations relatives à l’accompagnant d’une Déclaration de Séjour :
        </h4>
        <ul>
          <li>Nom</li>
          <li>Prénoms</li>
          <li>Date de naissance</li>
          <li>Compétences</li>
          <li>Fonction</li>
          <li>Téléphone</li>
        </ul>

        <p>
          Conformément au Règlement Européen Général de Protection des Données,
          et notamment à l’article 13 de celui-ci, l’Utilisateur est informé que
          la collecte de ces données à caractère personnel a pour finalités :
        </p>

        <ul>
          <li>
            L’instruction des Déclarations de Séjour, Déclarations des
            Événements Indésirables Graves par les DDETS et DREETS afin de
            décider des autorisations à accorder à l’OVA, porteur de la
            Déclaration
          </li>
          <li>
            La production de données statistiques anonymes d’utilisation du Site
            en France et dans les régions et départements d’Outre-mer
          </li>
        </ul>
      </section>
    </section>

    <section aria-labelledby="article-8-cookies">
      <h2 id="article-8-cookies">8. Cookies</h2>

      <p>
        Aucune donnée à caractère personnel n'est collectée via l’usage de
        cookie.
      </p>

      <p>
        Un cookie est automatiquement installé sur ou être lu depuis un support
        numérique. Un cookie est un élément qui ne permet pas d'identifier
        l'Utilisateur mais sert à enregistrer des informations relatives à la
        navigation de celui-ci sur le Site.
      </p>

      <p>
        Sur le Site, un cookie de session est mis en place avec pour une durée
        de vie de session de l’Utilisateur. Une session désigne une visite
        individuelle, initiée par un utilisateur.
      </p>

      <p>
        Une session prend fin après 30 minutes d’inactivité de la part de
        l’Utilisateur ou s’il quitte le Site et ne revient pas dans les 30
        minutes qui suivent. Dans le cas contraire, elle est renouvelée toutes
        les 30 minutes. Le cookie est automatiquement détruit à la déconnexion
        manuelle opérée par l’utilisateur.
      </p>

      <p>
        Une fois connecté sur le Site, l’Utilisateur est identifié à l’aide de
        ce cookie de session afin de lui permettre de naviguer sans se
        reconnecter à chaque changement de page.
      </p>
    </section>

    <section aria-labelledby="article-9">
      <h2 id="article-9">
        9. Clause relative à l’hameçonnage (phishing) et à la sécurité
      </h2>

      <p>
        L’Utilisateur est informé que des tentatives de fraude, notamment par
        hameçonnage (phishing), peuvent survenir. Le phishing consiste à se
        faire passer pour un tiers de confiance afin d’obtenir des informations
        personnelles, des identifiants ou des données sensibles.
      </p>

      <p>À ce titre :</p>

      <ul>
        <li>
          L’Utilisateur s’engage à ne jamais communiquer ses identifiants, mots
          de passe ou données sensibles à un tiers, quels que soient le support
          ou le prétexte invoqué.
        </li>
        <li>
          L’Utilisateur est responsable de la confidentialité et de la sécurité
          de ses accès.
        </li>
        <li>
          L’Utilisateur doit s’assurer de l’authenticité des communications
          qu’il reçoit prétendument du Site VAO, notamment en vérifiant
          l’adresse de l’expéditeur et en évitant de cliquer sur des liens
          suspects.
        </li>
      </ul>

      <p>Le Site VAO ne pourra en aucun cas être tenu responsable :</p>

      <ul>
        <li>
          des pertes, dommages ou préjudices résultant d’une tentative de
          phishing ou de fraude externe ;
        </li>
        <li>
          de toute utilisation frauduleuse des identifiants de l’Utilisateur
          résultant d’une négligence de sa part.
        </li>
      </ul>

      <p>
        En cas de doute ou de tentative suspecte, l’Utilisateur est invité à
        contacter immédiatement le support officiel via les canaux de
        communication indiqués sur le site.
      </p>

      <p>
        En complément, les représentants du site ou de l’assistance utilisateur
        ne demanderont jamais la communication de vos identifiants personnels et
        de votre mot de passe.
      </p>
    </section>

    <section aria-labelledby="article-10">
      <h2 id="article-10">10. Modification des CGU</h2>

      <p>
        Les présentes CGU peuvent être modifiées à tout moment par l’éditeur.
        Les utilisateurs sont invités à les consulter régulièrement.
      </p>
    </section>

    <section aria-labelledby="article-11">
      <h2 id="article-11">11. Droit applicable</h2>

      <p>
        Les présentes CGU sont soumises au droit français. En cas de litige, les
        tribunaux français sont compétents.
      </p>
    </section>
    <div v-if="props.allowValidation">
      <DsfrCheckbox
        v-model="acceptationCgu"
        name="acceptation cgu"
        label="Veuillez lire et accepter les Conditions Générales d'Utilisation"
        :small="true"
        @update:model-value="true"
      />
      <div class="fr-fieldset">
        <div class="fr-col-3">
          <div class="fr-input-group">
            <DsfrButton
              id="valider-cgu"
              :secondary="false"
              :disabled="!acceptationCgu"
              type="button"
              @click="onValidate"
            >
              Valider
            </DsfrButton>
          </div>
        </div>
        <div class="fr-col-4" style="justify-content: right">
          <div class="fr-input-group">
            <DsfrButton
              id="refuser-cgu"
              type="button"
              :secondary="true"
              @click="onRefuse"
              >Refuser
            </DsfrButton>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script setup>
import { DsfrButton } from "@gouvminint/vue-dsfr";
const acceptationCgu = ref(false);

const emit = defineEmits(["refuse", "validate", "close"]);
const props = defineProps({
  allowValidation: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const onRefuse = () => {
  emit("refuse");
};

const onValidate = () => {
  emit("validate");
};
</script>

<style scoped>
.small-headings h1,
.small-headings h2,
.small-headings h3,
.small-headings h4 {
  white-space: nowrap;
  transform: scale(0.6);
  transform-origin: left;
}
</style>
